import http from "./HttpService";

const endpoint = process.env.VUE_APP_INTERVIEW_RESERVE_URL + "/api/" + "admin";

const getSetting = () => {
  return http.get(endpoint + "/setting");
};

const editSetting = (times) => {
  return http.put(
    endpoint + "/setting",
    {
      workingSaturday: times.workingSaturday,
      workingSunday: times.workingSunday,
      workingMonday: times.workingMonday,
      workingTuesday: times.workingTuesday,
      workingWednesday: times.workingWednesday,
      workingThursday: times.workingThursday,
      workingFriday: times.workingFriday,
    }
  );
};

export default { getSetting, editSetting };
